import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  static targets = ['item']

  declare itemTargets: HTMLDivElement[]

  connect(): void {
    this.#syncRemoveButtons()
  }

  #modifiedClonedItem(clonedItem: HTMLElement): HTMLElement {
    // differentiate popover triggers in the new cloned item
    clonedItem.querySelectorAll('button').forEach(button => {
      if (button.hasAttribute('popovertarget')) {
        const oldTargetId = button.getAttribute('popovertarget') ?? ''
        const newTargetId = oldTargetId + `-clone-${Math.random()}`
        button.setAttribute('popovertarget', newTargetId)
        clonedItem.querySelector('#' + oldTargetId)?.setAttribute('id', newTargetId)
      }
    })
    clonedItem.querySelectorAll('[type="hidden"]').forEach(input => {
      if (input.hasAttribute('name')) {
        const name = input.getAttribute('name') || ''
        const isDestroyOrId = /\[(id|_destroy)]$/.test(name)
        if (input.parentNode && isDestroyOrId) {
          input.parentNode.removeChild(input)
        }
      }
    })
    // replace names like "field_name[0][type]..." in the new cloned item
    clonedItem.innerHTML = clonedItem.innerHTML.replace(/\[\d+]/g, `[${Date.now()}]`)
    // remove ids and clear only user-entered text-like values in the new cloned item
    clonedItem.querySelectorAll('input').forEach(input => {
      input.removeAttribute('id')
      if (this.#isTextInput(input)) {
        input.value = ''
      }
    })

    return clonedItem
  }

  add(): void {
    const firstItem = this.itemTargets[0]
    const clonedItem = firstItem.cloneNode(true) as HTMLDivElement

    firstItem.parentElement?.appendChild(this.#modifiedClonedItem(clonedItem))

    this.#syncRemoveButtons()
  }

  remove(e: MouseEvent): void {
    const button = e.currentTarget as HTMLButtonElement
    const row = button?.parentElement?.parentElement

    this.#keepIdAndDestroy(row)

    row?.remove()

    this.#syncRemoveButtons()
  }

  #syncRemoveButtons(): void {
    // Hide remove button only if there's a single item
    const shouldHide = this.itemTargets.length <= 1

    this.element.querySelectorAll('.via-clone-box-remove').forEach(button => {
      button.classList.toggle('hidden', shouldHide)
    })
  }

  #keepIdAndDestroy(target?: HTMLElement | null) {
    if (!target) return

    target.querySelectorAll('[type="hidden"]').forEach(input => {
      const name = input.getAttribute('name') || ''
      if (/\[_destroy]$/.test(name)) {
        ;(input as HTMLInputElement).value = String(1)
        target?.parentNode?.appendChild(input)
      }
      if (/\[id]$/.test(name)) {
        target?.parentNode?.appendChild(input)
      }
    })
  }

  #isTextInput(input: HTMLInputElement): boolean {
    return input.type === '' || input.type === 'text'
  }
}
